import React from 'react';

export const CheckMarkIcon = ({ fill = '#D7BD35' }: { fill?: string }) => {
  return (
    <svg width="7" height="5" viewBox="0 0 7 5" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7 0.7L2.66906 5L0 2.3L0.705036 1.6L2.66906 3.55L6.29496 0L7 0.7Z" fill={fill} />
    </svg>
  );
};
